import { Collection } from '@/kernel/collection';

import StringCell from '@/components/cells/string-cell.vue';
import DateCell from '@/components/cells/date-cell.vue';
import BooleanCell from '@/components/cells/boolean-cell.vue';
import EditCollectionCell from '@/components/cells/edit-collection-cell.vue';
import CollectionNameCell from '@/components/cells/collection-name-cell.vue';

import { DateRangeFilterAdapter, SelectFilterAdapter, SingleRelationFilterAdapter, SingleRelationInputAdapter } from '@/kernel/adapters';

import DateRangeInput from '@/components/inputs/date-range-input.vue';
import TextInput from '@/components/inputs/text-input.vue';
import CheckboxInput from '@/components/inputs/checkbox-input.vue';
import SelectInput from '@/components/inputs/select-input.vue';
import SingleRelationInput from '@/components/inputs/single-relation-input.vue';

const isSuspendedOptions = [
  {value: null, label: 'Any'},
  {value: false, label: 'Active'},
  {value: true, label: 'Suspended'}
];

export class User extends Collection {
  config = {
    autoRoute: true,
    requiresSuperAdmin: true,
    key: 'user',
    pluralLabel: 'Users',
    singleLabel: 'User',
    indexUrl: '/user',
    createUrl: '/user/create',
    searchKeys: ['name', 'email', 'sub'],
    editUrlPrefix: '/user',
    idKey: 'id',
    nameKey: 'name',
    payloadEndpoint: '/user',
    defaultSort: {
      key: 'name',
      order: 1
    },
    indexColumns: [
      {name: 'Actions', key: 'edit', sortable: false, cell: EditCollectionCell, props: {collection: 'user'}},
      {name: 'Name', key: 'name', sortable: true, cell: StringCell},
      {name: 'Email', key: 'email', sortable: true, cell: StringCell},
      {name: 'Sub', key: 'sub', sortable: false, cell: StringCell},
      {name: 'Organisation', key: 'organisation', sortable: false, cell: CollectionNameCell, props: {collection: 'organisation'}},
      {name: 'Is Suspended', key: 'isSuspended', sortable: false, cell: BooleanCell},
      {name: 'Updated', key: 'updatedAt', sortable: true, cell: DateCell},
      {name: 'Created', key: 'createdAt', sortable: true, cell: DateCell}
    ],
    indexFilters: [
      {key: 'organisation', label: 'Organisation', input: SingleRelationInput, adapter: SingleRelationFilterAdapter('organisation'), props: {label: 'Organisation', collection: 'organisation'}},
      {key: 'isSuspended', label: 'Is Suspended', input: SelectInput, adapter: SelectFilterAdapter, props: {label: 'Is Suspended', options: isSuspendedOptions}},
      {key: 'updatedAt', label: 'Updated at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Updated at'}},
      {key: 'createdAt', label: 'Created at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Created at'}}
    ],
    createFormFields: [
      {key: 'isSuperAdmin', label: 'Is Super Admin', input: CheckboxInput, props: {label: 'Is Super Admin'}},
      {key: 'isSuspended', label: 'Is Suspended', input: CheckboxInput, props: {label: 'Is Suspended'}},
      {key: 'hasWritePermission', label: 'Has Write Permission', input: CheckboxInput, props: {label: 'Has Write Permission'}},
      {key: 'organisation', label: 'Organisation', input: SingleRelationInput, adapter: SingleRelationInputAdapter('organisation'), props: {label: 'Organisation', collection: 'organisation'}},
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'email', label: 'Email', input: TextInput, props: {label: 'Email'}},
      {key: 'sub', label: 'Auth0 ID', input: TextInput, props: {label: 'Auth0 ID'}},
    ],
    editFormFields: [
      {key: 'isSuperAdmin', label: 'Is Super Admin', input: CheckboxInput, props: {label: 'Is Super Admin'}},
      {key: 'isSuspended', label: 'Is Suspended', input: CheckboxInput, props: {label: 'Is Suspended'}},
      {key: 'hasWritePermission', label: 'Has Write Permission', input: CheckboxInput, props: {label: 'Has Write Permission'}},
      {key: 'organisation', label: 'Organisation', input: SingleRelationInput, adapter: SingleRelationInputAdapter('organisation'), props: {label: 'Organisation', collection: 'organisation'}},
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'email', label: 'Email', input: TextInput, props: {label: 'Email'}},
      {key: 'sub', label: 'Auth0 ID', input: TextInput, props: {label: 'Auth0 ID'}},
    ]
  }
}